import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormIoSkeletonModule } from '../../../shared/components';
import { DeleteDialogModule } from '../../../shared/components/delete-dialog/delete-dialog.module';
import { FormioPipesModule } from '../../../shared/pipes';
import {
  QuestionsContainerComponent,
  QuestionsContainerSideComponent,
  QuestionsListComponent,
  UsersSessionsDialogComponent,
} from './components';
import { QuestionItemComponent } from './components/question-item/question-item.component';
import { QuestionsResourceListComponent } from './components/questions-resource-list/questions-resource-list.component';
import { DistributeCommonQuestionsComponent } from './distribute-common-questions.component';
import { CommonQuestionsService, QuestionsStoreService } from './services';
import { MembersLengthPipe } from './pipes/members-length.pipe';

@NgModule({
  declarations: [
    DistributeCommonQuestionsComponent,
    QuestionsResourceListComponent,
    QuestionsListComponent,
    UsersSessionsDialogComponent,
    QuestionsContainerSideComponent,
    QuestionsContainerComponent,
    QuestionItemComponent,
    MembersLengthPipe,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MatListModule,
    MatButtonModule,
    MatCheckboxModule,
    MatIconModule,
    FormIoSkeletonModule,
    MatDialogModule,
    FormioPipesModule,
    MatSidenavModule,
    MatTooltipModule,
    DeleteDialogModule,
  ],
  entryComponents: [DistributeCommonQuestionsComponent],
  exports: [DistributeCommonQuestionsComponent],
  providers: [CommonQuestionsService, QuestionsStoreService],
})
export class DistributeCommonQuestionsModule {}
